import React from 'react'
import { Lottie as BaseLottie, type LottieProps } from '@node-space/ui-components'
import { useThemeContext } from 'hooks/context/useThemeContext'

const Lottie: React.FC<Omit<LottieProps, 'darkMode'>> = props => {
  const { darkMode } = useThemeContext()
  return <BaseLottie darkMode={darkMode} {...props} />
}

export { Lottie }
